module.exports = __webpack_public_path__ + "img/medidas_doble.30beea59.png";